import React from 'react';
import '../../../pages/doctube/doctubeProfileManagement/scss/dt_profile.scss';
import '../../../pages/doctube/doctubeProfileManagement/scss/dt_profileRight.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../../../components/ContentSlider/css/contentSlider.scss';
import { Skeleton } from '../../Skeleton';

const AnalyticMetrixSkeleton = () => {
  return (
    <>
      <div className="w-100 dt_Counts bg-white shadow rounded-3 position-relative mb-5 d-flex flex-column p-3 p-md-4">
        <div className="doctubeLogo mb-4">
          <Skeleton variant="text" width={150} height={50} />
        </div>
        {/* <h5 className="fs-4 fw-normal text-black mb-4">
          <Skeleton variant="text" width={280} height={20} />
        </h5> */}
        <div className="counts d-flex justify-content-center mb-4 gap-5">
          <div className="singleCount text-center">
            <h4 className="countNum mb-3 pb-3 fs-2 fw-semibold text-black position-relative">
              <Skeleton variant="text" width={30} height={30} />
            </h4>
            <h6 className="countName fs-4 fw-medium">
              <Skeleton variant="text" width={30} height={30} />
            </h6>
          </div>
          <div className="singleCount text-center">
            <h4 className="countNum mb-3 pb-3 fs-2 fw-semibold text-black position-relative">
              <Skeleton variant="text" width={30} height={30} />
            </h4>
            <h6 className="countName fs-4 fw-medium">
              <Skeleton variant="text" width={30} height={30} />
            </h6>
          </div>
          <div className="singleCount text-center">
            <h4 className="countNum mb-3 pb-3 fs-2 fw-semibold text-black position-relative">
              <Skeleton variant="text" width={30} height={30} />
            </h4>
            <h6 className="countName fs-4 fw-medium">
              <Skeleton variant="text" width={30} height={30} />
            </h6>
          </div>
        </div>
        <Skeleton variant="rectangular" width={'100%'} height={50} className="rounded-3" />
      </div>
    </>
  );
};

export default AnalyticMetrixSkeleton;
